import VueI18n from "vue-i18n";

function stringMaxLength(i18n: VueI18n, field: VueI18n.TranslateResult, length: number) {
  return (v: string) =>
    (v && v.length <= length) || !v || i18n.t("common.validationErrorMaxLength", { field: field, length: length });
}

export { stringMaxLength };
